import script from "./HowItWorksValidityCheckForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorksValidityCheckForm.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorksValidityCheckForm.vue?vue&type=style&index=0&id=85028d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85028d8c"]])

export default __exports__